import { render, staticRenderFns } from "./ModelPriceTable.vue?vue&type=template&id=7cc0baba"
import script from "./ModelPriceTable.vue?vue&type=script&lang=js"
export * from "./ModelPriceTable.vue?vue&type=script&lang=js"
import style0 from "./ModelPriceTable.vue?vue&type=style&index=0&id=7cc0baba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e7c46a58a2b84365ed6c46ff010356d5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports